import { siteInfo } from "@/mocks/articles";

interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "Article" | "BreadcrumbList" | "FAQPage";
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseUrl = siteInfo.domain;

  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: baseUrl,
      description: siteInfo.description,
      foundingDate: siteInfo.foundingDate,
      ...data,
    },
    WebSite: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: baseUrl,
      description: siteInfo.description,
      inLanguage: "zh-CN",
      ...data,
    },
    WebPage: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: siteInfo.name,
      url: baseUrl,
      description: siteInfo.description,
      inLanguage: "zh-CN",
      isPartOf: {
        "@type": "WebSite",
        name: siteInfo.name,
        url: baseUrl,
      },
      ...data,
    },
    Article: {
      "@context": "https://schema.org",
      "@type": "Article",
      inLanguage: "zh-CN",
      isPartOf: {
        "@type": "WebSite",
        name: siteInfo.name,
        url: baseUrl,
      },
      publisher: {
        "@type": "Organization",
        name: siteInfo.name,
        url: baseUrl,
      },
      ...data,
    },
    BreadcrumbList: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      ...data,
    },
    FAQPage: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      ...data,
    },
  };

  const schema = schemas[type] || {};

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}